import React from "react";
import { Link } from "react-router-dom";
import "./index.css";

export default class Notfound extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      time: 5
    };
  }

  componentDidMount(){
    this.timeFun();
  }

  timeFun(){
    this.setState({
      time: this.state.time - 1
    },() => {
      if(this.state.time <= 0){
        document.location.href = document.location.origin;
      }else{
        setTimeout(()=>{
          this.timeFun();
        },1000);
      }
    });
  }

  render() {
    return (
      <div className="page" ref={node => (this.node = node)}>
        <div className="box">{this.state.time}秒后跳转到首页...(<Link to='/' className="go_btn">立即跳转</Link>)</div>
      </div>
    );
  }
}
